type Panel = typeof import('@/components/SheetPanel').SheetPanel;
type Zoom = typeof import('@/components/ZoomView').ZoomView;

let panel: Panel | null = null;
let panelLoad: Promise<Panel | null> | null = null;
let zoom: Zoom | null = null;

export const sheetPanel = (): Panel | null => panel;

export function loadSheet(): Promise<Panel | null> {
  panelLoad ??= import('@/components/SheetPanel').then(
    (m) => (panel = m.SheetPanel),
    () => {
      panelLoad = null;
      return null;
    },
  );
  return panelLoad;
}

export function loadZoom(): Promise<Zoom | null> {
  if (zoom) return Promise.resolve(zoom);
  return import('@/components/ZoomView').then(
    (m) => (zoom = m.ZoomView),
    () => null,
  );
}
